import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: row;
`;

export const LeftDescription = styled('div')`
    width: 50%;
    height: 100vh;
    background-color: ${({ theme }) => theme.palette.white.main};

    @media (max-width: ${theme.breakpoints.values.md}px) {
        width: 100%;
    }

    .logo {
        position: relative;
        top: 20px;
        left: 20px;
        width: 160px;
    }
`;

export const Content = styled('div')`
    display: flex;
    flex-direction: column;

    justify-content: stretch;
    align-items: flex-start;

    gap: 32px;
    margin-top: 60px;
    margin-left: 24px;
    margin-right: 24px;
`;

export const RightDescription = styled('div')`
    width: 50%;
    overflow: auto;
    background-color: ${({ theme }) => theme.palette.primary.main};

    @media (max-width: ${theme.breakpoints.values.md}px) {
        display: none;
    }

`;

export const Title = styled('div')`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  color: ${theme.palette.primary.main};
  gap: 8px;
  font-weight: 700;
  font-size: 32px;
`;
